<ng-container *ngIf="cart">
  <div *ngFor="let screeningItem of cart.screeningItems; let i = index"
       class="cart-movie-summary-container d-none d-sm-block text-start text-sm-center text-md-start">
    <hr role="none" *ngIf="i !== 0" />
    <nt-container [ngTemplateOutlet]="movieTitleWithDescription"
                  [ngTemplateOutletContext]="{ data: screeningItem }"></nt-container>
    <div>
      {{ 'layout.header.languagechange.' + screeningItem.items[0].movieLanguage.toLowerCase() | translate }}
      {{
        screeningItem.items[0].screeningDuration
          ? ' - ' +
            (screeningItem.items[0].screeningDuration
              | timeParse : 'M' : 'HOURS_MINUTES' : ('shared.hourSymbol' | translate) : ('shared.minuteSymbol' | translate))
          : ''
      }}
    </div>
    <div *ngIf="screeningItem.items[0].movieSubtitles && screeningItem.items[0].movieSubtitles.length > 0">
      {{ 'screen.movie.subtitles' | translate }}:
      <span *ngFor="let lang of screeningItem.items[0].movieSubtitles">
        {{ 'layout.header.languagechange.' + lang.toLowerCase() | translate }}
      </span>
    </div>
    <app-screen-movie-movie-poster-component [posterUrl]="screeningItem.items[0].getMoviePoster()"
                                             [movieDescription]="screeningItem.items[0].movieDescription"
                                             [movieName]="screeningItem.items[0].getMovieTitle()"></app-screen-movie-movie-poster-component>
    <div>
      {{ screeningItem.items[0].screeningTimeFrom | dateTime : 'DATE_DMY' }}
    </div>
    <div class="d-inline-block d-sm-block">
      <span class="fw-bold screen-feature">{{ screeningItem.items[0].screenFeature }}</span>
      <span class="fw-bold pe-1" dir="ltr"> {{ screeningItem.items[0].screeningTimeFrom | dateTime : '12H' }}</span>
      <span class="fw-bold movie-print-type" dir="ltr"> ({{ screeningItem.items[0].moviePrintType }}) </span>
    </div>
    <p>
      {{ screeningItem.items[0].screenName }}
    </p>
  </div>
</ng-container>

<ng-container *ngIf="cart">
  <div *ngFor="let screeningItem of cart.screeningItems"
       class="cart-movie-summary-container text-center d-block d-sm-none">
    <hr role="none" />
    <nt-container [ngTemplateOutlet]="movieTitleWithDescription"
                  [ngTemplateOutletContext]="{ data: screeningItem }"></nt-container>
    <span (click)="showMore[screeningItem.screeningId] = !showMore[screeningItem.screeningId]" class="more">
      <span [hidden]="showMore[screeningItem.screeningId]">{{ 'screen.movie.more_info' | translate }} <i
           class="fa fa-chevron-down"></i></span>
    </span>
    <div [hidden]="!showMore[screeningItem.screeningId]">
      <div class="cinema-street" *ngIf="cinema?.name">
        {{ cinema.name.toTranslationKey('screen.cinema') | translate }}
      </div>
      <p>
        {{ 'layout.header.languagechange.' + screeningItem.items[0].movieLanguage.toLowerCase() | translate }}
        - {{ screeningItem.items[0].screeningDuration | timeParse : 'M' : 'HOURS_MINUTES' }}
        <span *ngIf="screeningItem.items[0].movieSubtitles && screeningItem.items[0].movieSubtitles.length > 0">
          | {{ 'screen.movie.subtitles' | translate }}:
          <span *ngFor="let lang of screeningItem.items[0].movieSubtitles">
            {{ 'layout.header.languagechange.' + lang.toLowerCase() | translate }}
          </span>
        </span>
      </p>
      <p class="d-inline-block d-sm-block">
        {{ screeningItem.items[0].screeningTimeFrom | dateTime : 'DATE_DMY' }} | <span
              class="fw-bold">{{ screeningItem.items[0].screenFeature }}</span><span class="fw-bold pe-1">
          {{ screeningItem.items[0].screeningTimeFrom | dateTime : '12H' }}</span>
        <span class="fw-bold movie-print-type" dir="ltr"> ({{ screeningItem.items[0].moviePrintType }}) </span>
      </p>
      <p class="d-block d-sm-block">
        {{ screeningItem.items[0].screenName }}
      </p>
    </div>
    <div (click)="showMore[screeningItem.screeningId] = !showMore[screeningItem.screeningId]" class="more pb-3">
      <span [hidden]="!showMore[screeningItem.screeningId]">{{ 'screen.movie.show_less' | translate }} <i
           class="fa fa-chevron-up"></i></span>
    </div>
  </div>
</ng-container>

<ng-template #movieTitleWithDescription let-screening="screening">
  <div class="movie-title">
    {{ screening.items[0].getMovieTitle() }}
    <span [innerHTML]="getDescription(screening)"></span>
  </div>
</ng-template>